import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import * as v1 from '@app/v1_integration';
import {Authenticate} from '@services/auth.services';
import {BaseService} from '@services/base.services';
import * as fromModels from '@shared/models';
import {TermStaffAccountDTO} from '@staff-app/models/termStaffAccountDTO';
import {environment} from 'environments/environment';
import {from, Observable} from 'rxjs';

@Injectable()
export class UserService extends BaseService {
  constructor(
    @Inject(v1.v1_breezeServiceName)
    private _breezeService: Pulse.Services.IBreezeService,
    private _htc: HttpClient
  ) {
    super();
  }

  getLoggedInUserAndRoles(): Observable<fromModels.UserAndRoleInfo> {
    const query = breeze.EntityQuery.from('User_GetLoggedInUserAndRoles')
      .noTracking(true)
      .take(1); // There should only be one.

    const promise = this._breezeService
      .getEntityManager()
      .executeQuery(query)

      .then(data => {
        const results = <fromModels.UserAndRoleInfo>(<any>data.results[0]);

        // this._breezeService.getEntityManager().clear(); //clear all entities.

        return results;
      });

    return from(promise);
  }
  getTokenForUser(userID: number): Observable<fromModels.UserToken> {
    const query = breeze.EntityQuery.from('UserToken_GenTokenForUser')
      .withParameters({
        userID: userID,
        sourceOrReason: 'job-app'
      })
      .noTracking(true)
      .take(1); // There should only be one.

    const promise = this._breezeService
      .getEntityManager()
      .executeQuery(query)

      .then(data => {
        const results = <fromModels.UserToken>(<any>data.results[0]);

        return results;
      });

    return from(promise);
  }
  prepareJobAppForUser(userID: number): Observable<number> {
    const params: any = {
      userID: userID
    };
    return this._htc.get(
      `${
        environment.webApi_NonBreeze
      }/TermStaff_PrepareJobApplicationForCurrentTermGroup`,
      {
        params: params
      }
    ) as Observable<number>;
  }

  createTermStaffAccount(
    payload: TermStaffAccountDTO
  ): Observable<Authenticate> {
    return this._htc
      .post(
        `${environment.webApi_NonBreeze}/UserAcct_CreateTermStaffAccount`,
        // @ts-ignore
        {...payload, password: Pulse.Utils.JS.toHashSHA256Base64(payload.password)},
        {
          headers: new HttpHeaders().set(
            'Content-Type',
            'application/json;charset=UTF-8'
          )
        }
      )
      .map(response => {
        // user id
        return {
          username: payload.email,
          password: payload.password
        };
      });
  }
}
